import { Api } from "./generated-proxies";

export const { REACT_APP_CLIENT_ID, REACT_APP_TENANT_ID, REACT_APP_APP_BASE_URL, REACT_APP_API_BASE_URL } = process.env;

const server = new Api();
export default server